module.exports = __webpack_public_path__ + "assets/images/rbyearend-20-desktop.jpg?v=41a69476";